export default __webpack_public_path__ + "static/media/envelopeIcon.9a98f28a.svg";